import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";

import { useStyles } from "./AddTimeTable.css";
import ClassDetails from "../ClassDetails/ClassDetails";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import TimeTableForm from "./TimeTableForm/TimeTableForm";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import { connect } from "react-redux";

class AddTimeTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      column: [
        { name: "S.N." },
        { name: "Subject" },
        { name: "From" },
        { name: "To" },
        { name: "Class Teacher" },
        { name: "Actions" },
      ],
      weekName: this.props.weekName,
      times: [],
    };
  }

  handleAddSubject = async (data, subjectId) => {
    try {
      const response = await Axios.put(
        `${url}/api/time-tables/${this.props.timeList._id}/subject/${this.props.weekId}/${subjectId}`,
        data,
        {
          headers: { Authorization: `Bearer ${this.props.adminToken}` },
        }
      );
      if (response.data.message === "Subject time table edited successfully") {
        this.setState({ loading: false });
        this.props.getTimeTable(this.props.config);
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleAddSubject(data, subjectId);
      }
    }
  };

  render() {
    const { classes, subjectList, weekName } = this.props;
    const filtered = subjectList
      .filter((data) => data.weekName === weekName)
      .find((data) => data);
    return (
      <div className={classes.root}>
        <h3>TimeTable for {weekName}</h3>
        <ClassDetails config={this.props.config} />
        <br />
        {filtered.subjects.length !== 0 && (
          <TableContainer>
            <Table>
              <CustomTableHead column={this.state.column} />
              <TableBody>
                {filtered.subjects.map((subject, index) => (
                  <TimeTableForm
                    key={index}
                    index={index}
                    data={subject}
                    weekName={this.state.weekName}
                    handleAddSubject={this.handleAddSubject}
                  />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    isAdmin: state.AdminReducer.isAdmin,
    role: state.AdminReducer.role,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(AddTimeTable));
